import { useDispatch, useSelector } from 'react-redux';
import { push } from 'redux-first-history';

import { Box, Text, TextButton } from '@zillow/constellation-10';

import RachelCSEvents from '@renter-hub/tracking/ClickStreamEvents';
import { closeNotification } from '@common/actions/NotificationActions';
import paths from '@renter-hub/pathsManifest';
import { MOVE_IN_COSTS_PAYMENT, RENT_PAYMENT } from '@renter-hub/constants/paymentConstants';
import type { RootState } from '../../../../store/types';

interface OnboardingProgressBarProps {
  progressTitle: string;
}
const OnboardingProgressBar = ({ progressTitle }: OnboardingProgressBarProps) => {
  const dispatch = useDispatch();
  const user = useSelector((state: RootState) => state.user);

  const onClickSaveAndExit = () => {
    const triggerObjectMap = {
      [MOVE_IN_COSTS_PAYMENT]: 'move_in_costs_page',
      [RENT_PAYMENT]: 'payment_settings_page',
      default: 'payment_info_page',
    };
    const triggerObject = triggerObjectMap[progressTitle] || triggerObjectMap.default;
    RachelCSEvents.emitClickFinishLaterEvent({
      user,
      triggerObject,
    });
    dispatch(closeNotification());
    dispatch(push(paths.baseUrl));
  };

  return (
    <Box
      css={{
        display: 'flex',
        alignItems: 'center',
        borderBottom: '1px solid #ddd',
        paddingBottom: 'tighter',
      }}
    >
      <Box css={{ flex: '1 1 auto' }}>
        <Text textStyle="body-bold">{progressTitle}</Text>
      </Box>
      <Box css={{ flex: '0 1 auto' }}>
        <TextButton textStyle="body-sm" onClick={onClickSaveAndExit}>
          Finish later
        </TextButton>
      </Box>
    </Box>
  );
};

export default OnboardingProgressBar;
